<template>
  <div class="material-list-group">
    <div class="material-list-group-item">
      <label class="material-radio">
        <input type="radio" value="bank" v-model="localValue" name="material-radio-group"/>
        <span class="material-radio-mark"></span>
        <span class="material-label">{{ $t("Use finnish online banking services") }}</span>
        <span class="float-right">
          <img style="" :src="`${base_url}images/payment_methods_logos/Banks/op.svg`">
          <img style="" :src="`${base_url}images/payment_methods_logos/Banks/nordea.svg`">
          <div class="more-images-box" @mouseover="showPopover = true" @mouseleave="showPopover = false">
            +{{ remainingImages.length }}
            <div v-if="showPopover" class="popover-box">
              <div class="popover-box-inner">
                <img v-for="(image_path, key) in remainingImages" :key="key" :src="`${base_url}${image_path}`" style="margin: 5px;" />
              </div>
            </div>
          </div>
        </span>
      </label>
    </div>
    <div class="material-list-group-item">
      <label class="material-radio">
        <input type="radio" value="creditcard" v-model="localValue" name="material-radio-group"/>
        <span class="material-radio-mark"></span>
        <span class="material-label">{{ $t("Pay with Visa or Mastercard") }}</span>
        <span class="float-right">
          <img style="" :src="`${base_url}images/payment_methods_logos/Cards/visa.svg`">
          <img style="" :src="`${base_url}images/payment_methods_logos/Cards/mastercard.svg`">
        </span>
      </label>
    </div>
    <div class="material-list-group-item" v-if="isSafari()">
      <label class="material-radio">
        <input type="radio" value="apple-pay" v-model="localValue" name="material-radio-group"/>
        <span class="material-radio-mark"></span>
        <span class="material-label">{{ $t("Pay with Apple") }}</span>
        <span class="float-right">
          <img style="" :src="`${base_url}images/payment_methods_logos/apple-pay-logo-icon.png`">
        </span>
      </label>
    </div>
    <div class="material-list-group-item">
      <label class="material-radio">
        <input type="radio" value="mobile" v-model="localValue" name="material-radio-group"/>
        <span class="material-radio-mark"></span>
        <span class="material-label">{{ $t("Pay with Mobile") }}</span>
        <span class="float-right">
          <img style="" :src="`${base_url}images/payment_methods_logos/mobile_pay.svg`">
        </span>
      </label>
    </div>
    <div class="material-list-group-item">
      <label class="material-radio">
        <input type="radio" value="klarna" v-model="localValue" name="material-radio-group"/>
        <span class="material-radio-mark"></span>
        <span class="material-label">{{ $t('Pay with Klarna') }}</span>
        <span class="float-right">
          <img style="" :src="`${base_url}images/payment_methods_logos/klarna.svg`">
        </span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "MaterialListGroup",
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      localValue: this.value,
      showPopover: false,
      remainingImages: [
        `images/payment_methods_logos/Banks/danske_bank.svg`,
        `images/payment_methods_logos/Banks/s-pankki.svg`,
        `images/payment_methods_logos/Banks/pop-pankki.svg`,
        `images/payment_methods_logos/Banks/omasp.svg`,
        `images/payment_methods_logos/Banks/aktia.svg`,
        `images/payment_methods_logos/Banks/handelsbanken.svg`,
        `images/payment_methods_logos/Banks/saastopankki.svg`,
        `images/payment_methods_logos/Banks/alandsbanken.svg`
      ]
    };
  },
  watch: {
    // Watch the value prop for changes from the parent component
    value(newVal) {
      this.localValue = newVal;
    },
    // Watch localValue for changes and emit to the parent
    localValue(newVal) {
      this.$emit("input", newVal); // Emit the `input` event for v-model binding
    },
  },
  methods : {
    isSafari() {
      return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    }
  }
};
</script>

<style scoped>
.material-list-group {
  display: flex;
  flex-direction: column;
  margin: 10px 0;
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 10px;
}

.material-list-group-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  border-bottom: 1px solid #eee;
}

.material-list-group-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.material-radio {
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 16px;
  flex-grow: 1;
}

.material-radio img {
  width: 50px; /* Adjust the width of the image */
  height: auto;
  margin-left: 10px;
  border-radius: 5px;
}

.float-right {
  margin-left: auto; /* Ensure the image floats to the right */
}

.material-radio input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.material-radio .material-radio-mark {
  position: relative;
  height: 18px;
  width: 18px;
  border-radius: 50%;
  border: 2px solid #ccc;
  display: inline-block;
  margin-right: 10px;
  transition: background 0.3s ease;
}

.material-radio input:checked ~ .material-radio-mark {
  background-color: #212529;
  border-color: #212529;
}

.material-radio .material-radio-mark::after {
  content: "";
  position: absolute;
  display: none;
  left: 4px;
  top: 4px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: white;
}

.material-radio input:checked ~ .material-radio-mark::after {
  display: block;
}

.material-label {
  color: #333;
  width: 50%;
}

.material-radio:last-child {
  margin-bottom: 0;
}

@media (max-width: 529px) {
  .material-list-group {
    padding: 0;
  }
  .material-label {
    font-size: 1rem;
    font-weight: normal;
    width: 40%;
  }

  .material-radio img {
    width: 40px; /* Adjust the width of the image */
    margin-left: 6px;
  }
}

/*---*/
.more-images-box {
  display: inline-block;
  margin-left: 10px;
  padding: 6px;
  border: 1px solid #e9e9e9;
  border-radius: 4px;
  cursor: pointer;
  background-color: #f8f9fa;
  font-size: 12px;
  width: 45px;
  text-align: center;
  font-weight: bold;
  position: relative;
}

.popover-box {
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  max-width: 250px;
  max-height: 200px;
}
.popover-box-inner {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(40px, 1fr));
  gap: 0.7rem;
  max-width: 240px;
  max-height: 190px;
  padding: 0.5rem;
  margin-right: 10px;
}

.popover-box-inner::-webkit-scrollbar-track
{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  -moz-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  background-color: #F5F5F5;
}

.popover-box-inner::-webkit-scrollbar
{
  width: 6px;
  background-color: #F5F5F5;
}

.popover-box-inner::-webkit-scrollbar-thumb
{
  background-color: #000000;
}

.popover-box img {
  width: 100%; /* Make images responsive to the container */
  height: auto; /* Keep image aspect ratio */
  border-radius: 4px; /* Optional: to add rounded corners to images */
}

.popover-box::before {
  content: "";
  position: absolute;
  top: 100%; /* Position the arrow at the bottom of the popover */
  left: 50%;
  transform: translateX(-50%);
  border-width: 8px;
  border-style: solid;
  border-color: #ffffff transparent transparent transparent; /* White arrow pointing down */
  z-index: 999; /* Ensure arrow stays on top of the box */
}


@media (max-width: 767px) {
  .popover-box {
    transform: translateX(-83%);
  }

  .popover-box::before {
    top: 100%;
    left: 83%;
    transform: translateX(-50%);
  }
}

@media (max-width: 529px) {
  .more-images-box {
    width: 40px;
    margin-left: 6px;
    font-size: 10px;
    padding: 4px;
  }
  .popover-box {
    max-width: 150px;
    max-height: 100px;
  }

  .popover-box .popover-box-inner {
    gap: 10px;
    max-width: 150px;
    max-height: 100px;
    width: 140px !important;
    height: 80px !important;
    padding: 10px;
    overflow-y: auto;
    margin: 2px 0;
  }

  .popover-box::before {
    left: 71%; /* Move the arrow closer to the left edge for mobile */
    transform: none;
  }
}
</style>
